import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Backdrop,
  makeStyles
} from '@material-ui/core'
import MessageAllHistoryList from './MessageAllHistoryList'

const useStyles = makeStyles(theme => ({
  dialog: {},
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

const MessageAllHistoryModal: React.FC<{
  isOpen: boolean
  closeHandler: () => void
}> = ({ isOpen, closeHandler }) => {
  const classes = useStyles()
  const handleClose = () => {
    closeHandler()
  }

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={isOpen}
      onClose={handleClose}
      BackdropComponent={Backdrop}
      closeAfterTransition
      className={classes.dialog}
    >
      <DialogContent>
        <MessageAllHistoryList />
      </DialogContent>
      <DialogActions className={classes.flexCenter}>
        <Button variant="contained" onClick={handleClose} color="primary">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MessageAllHistoryModal
